module.exports = __webpack_public_path__ + "static/media/C005.beed6899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C005.jpg
// module id = 288
// module chunks = 0